import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
export default {
  methods: {
    async initTooltips(globalTooltipOptions = {}) {
      var _context;
      await this.$nextTick();
      _findInstanceProperty(_context = $(this.$el)).call(_context, "[data-toggle='tooltip']").tooltip(globalTooltipOptions);
    },
    async destroyTooltips() {
      var _context2;
      await this.$nextTick();
      _findInstanceProperty(_context2 = $(this.$el)).call(_context2, "[data-toggle='tooltip']").tooltip("dispose");
    }
  }
};